(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veyra-enlace-konfigurator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('veyra-duo-config')){
    customElements.define('veyra-duo-config',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;
        if(!this.querySelector('[data-messages]')){
          this.observer=new MutationObserver(()=>{if(this.querySelector('[data-messages]')){this.observer.disconnect();this.connectedCallback()}});
          this.observer.observe(this,{childList:true,subtree:true});
          return;
        }
        this.ready=true;
        this.messages=JSON.parse(this.querySelector('[data-messages]').textContent);
        this.max=Number(this.dataset.max);
        this.add=this.querySelector('[data-vd-add]');
        this.label=this.querySelector('[data-vd-add-text]');
        this.originalLabel=this.label.textContent;
        this.error=this.querySelector('[data-error]');
        this.status=this.querySelector('[data-status]');
        this.cart=this.querySelector('[data-cart]');
        this.controls=[...this.querySelectorAll('input,[data-copy]')];
        this.add.addEventListener('click',()=>this.submit());
        this.querySelector('[data-copy]').addEventListener('click',()=>this.copy());
        this.addEventListener('input',()=>this.edit());
        this.addEventListener('change',()=>this.edit());
        this.update();
      }
      normal(value){return value.normalize('NFC').trim().toUpperCase()}
      card(number){return this.querySelector('[data-bracelet="'+number+'"]')}
      selected(card,key){return card.querySelector('[data-choice="'+key+'"] input:checked')?.value||''}
      values(number){const card=this.card(number);return {color:this.selected(card,'color'),model:this.selected(card,'model'),left:this.normal(card.querySelector('[data-name="links"]').value),right:this.normal(card.querySelector('[data-name="rechts"]').value)}}
      update(){
        [1,2].forEach(number=>{
          const card=this.card(number);
          const color=this.selected(card,'color');
          card.dataset.metal=color==='Gold'?'gold':color==='Silber'?'silver':'neutral';
          const value=this.values(number);
          const validName=name=>!!name&&[...name].length<=this.max&&/^\p{Script=Latin}[\p{Script=Latin}\p{M} -]*$/u.test(name);
          card.querySelector('.card-ready').hidden=!(value.color&&value.model&&validName(value.left)&&validName(value.right));
          card.querySelectorAll('[data-name]').forEach(input=>{
            const value=this.normal(input.value);
            input.closest('.vd-field').querySelector('[data-count]').textContent=[...value].length;
            const placeholder=input.dataset.name==='links'?this.messages.preview_left:this.messages.preview_right;
            card.querySelector('[data-preview="'+input.dataset.name+'"]').textContent=value||placeholder;
          });
        });
        this.add.disabled=this.dataset.available!=='true'||!!this.busy||!!this.uncertain||!!this.added;
      }
      edit(){
        if(this.busy)return;
        this.error.hidden=true;
        this.status.hidden=true;
        this.querySelectorAll('[aria-invalid]').forEach(input=>input.removeAttribute('aria-invalid'));
        if(!this.uncertain){this.added=false;this.label.textContent=this.originalLabel;this.cart.hidden=true}
        this.update();
      }
      copy(){
        if(this.busy||this.uncertain)return;
        const first=this.card(1),second=this.card(2);
        ['color','model'].forEach(key=>{
          const value=this.selected(first,key);
          second.querySelectorAll('[data-choice="'+key+'"] input').forEach(input=>{input.checked=input.value===value});
        });
        ['links','rechts'].forEach(side=>{second.querySelector('[data-name="'+side+'"]').value=first.querySelector('[data-name="'+side+'"]').value});
        this.edit();
      }
      validate(){
        let first=null,invalid=false;
        const mark=input=>{input.setAttribute('aria-invalid','true');first=first||input};
        this.querySelectorAll('[aria-invalid]').forEach(input=>input.removeAttribute('aria-invalid'));
        this.querySelectorAll('[data-choice]').forEach(group=>{if(!group.querySelector('input:checked'))group.querySelectorAll('input').forEach(mark)});
        this.querySelectorAll('[data-name]').forEach(input=>{
          const value=this.normal(input.value);
          if(!value)mark(input);
          else if([...value].length>this.max||!/^\p{Script=Latin}[\p{Script=Latin}\p{M} -]*$/u.test(value)){invalid=true;mark(input)}
        });
        if(first){
          this.error.textContent=invalid?this.messages.invalid:this.messages.missing;
          this.error.hidden=false;
          first.focus({preventScroll:true});
          first.closest('.vd-card').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
          return false;
        }
        return true;
      }
      lock(locked){this.controls.forEach(control=>{control.disabled=locked})}
      async submit(){
        if(this.busy||this.uncertain||this.added||this.dataset.available!=='true')return;
        this.error.hidden=true;
        this.status.hidden=true;
        if(!this.validate())return;
        const properties={};
        [1,2].forEach(number=>{
          const value=this.values(number),prefix='Armband '+number+' · ';
          properties[prefix+'Farbe & Modell']=value.color+' - '+value.model;
          properties[prefix+'Gravur links']=value.left;
          properties[prefix+'Gravur rechts']=value.right;
        });
        this.busy=true;
        this.lock(true);
        this.add.setAttribute('aria-busy','true');
        this.label.textContent=this.messages.adding;
        this.update();
        let definite=false;
        try{
          const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:1,properties}]})});
          definite=response.status>=400&&response.status<500;
          const data=await response.json();
          if(!response.ok)throw new Error(typeof data.description==='string'?data.description:this.messages.failed);
          this.added=true;
        }catch(error){
          this.uncertain=!definite;
          this.error.textContent=definite?(error.message||this.messages.failed):this.messages.uncertain;
          this.error.hidden=false;
          this.cart.hidden=!this.uncertain;
        }finally{
          this.busy=false;
          this.add.removeAttribute('aria-busy');
          this.lock(!!this.uncertain);
          this.label.textContent=this.added?this.messages.added:this.originalLabel;
          this.update();
        }
        if(this.added){
          this.status.textContent=this.messages.added;
          this.status.hidden=false;
          this.cart.hidden=false;
          document.dispatchEvent(new CustomEvent('veyra:cart-added'));
          if(typeof window.upcartOpenCart==='function')window.upcartOpenCart();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veyra-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veyra-localization')) {
    customElements.define('veyra-localization', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const options = { signal: this.abort.signal };
        const form = this.querySelector('form');
        form?.addEventListener('submit', () => {
          try { sessionStorage.setItem('veyra:locale:manual', '1'); } catch (_) {}
          document.cookie = 'veyra-locale-manual=1; Path=/; SameSite=Lax; Secure';
          const language = form.elements.namedItem('language_code')?.value;
          if (language) {
            document.cookie = `ly-lang-selected=${encodeURIComponent(language)}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
          }
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) details.open = false;
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            details.open = false;
            summary.focus();
          }
        }, options);
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veyra-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('.vm-drawer');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';
    const openers = document.querySelectorAll('[data-vh-open]');
    const mega = document.querySelector('[data-vm-mega]');
    let previousOverflow = '', opener;
    openers.forEach(button => button.addEventListener('click', () => {
      opener = button;
      previousOverflow = document.body.style.overflow;
      drawer.showModal();
      document.body.style.overflow = 'hidden';
      button.setAttribute('aria-expanded', 'true');
      drawer.querySelector('[data-vh-close]').focus();
    }));
    drawer.querySelector('[data-vh-close]').addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', event => {
      const bounds = drawer.getBoundingClientRect();
      if (event.target === drawer && (event.clientX < bounds.left || event.clientX >= bounds.right)) drawer.close();
    });
    drawer.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
      drawer.querySelectorAll('details').forEach(item => item.open = false);
      opener?.focus();
    });
    if (mega) {
      document.addEventListener('click', event => { if (!mega.contains(event.target)) mega.open = false; });
      mega.addEventListener('keydown', event => {
        if (event.key === 'Escape' && mega.open) { mega.open = false; mega.querySelector('summary').focus(); event.stopPropagation(); }
      });
      mega.addEventListener('focusout', () => requestAnimationFrame(() => { if (!mega.contains(document.activeElement)) mega.open = false; }));
    }
    const desktop = window.matchMedia('(min-width: 1000px)');
    desktop.addEventListener('change', event => { if (event.matches && drawer.open) drawer.close(); if (!event.matches && mega) mega.open = false; });
  })();
  } catch(e) { console.error(e); }
})();

})();
